<div class="container" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> Emission Overview
  </p>

  <!-- TABLE HEADER -->
  <div class="toolbar">
    <div class="header-content">
      <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
        Emission Overview
      </h2>
      <div class="header-subtitle">Analyze and monitor vessel performance metrics</div>
    </div>

    <div class="header-actions">
      <!-- <button mat-flat-button class="column-filter-btn" (click)="openColumnFilterDialog()"
        matTooltip="Customize Visible Columns">
        <mat-icon>view_column</mat-icon>
        Select Columns
      </button> -->
      <button mat-flat-button class="back-dashboard-btn" (click)="goToPreviousPage()" matTooltip="Go Back to Dashboard">
        <mat-icon>arrow_back</mat-icon>
        <span>Back</span>
      </button>
    </div>
  </div>

  <!-- GROUP SELECTOR BAR -->
  <div class="premium-toggle-container">
    <div class="toggle-instruction">Toggle Column Groups:</div>
    <div class="group-toggle-bar">
      <div *ngFor="let group of columnGroups" class="group-pill" [class.active]="group.visible"
        (click)="toggleGroupVisibility(group)" matTooltip="{{ group.visible 
          ? 'Click to hide ' + group.label 
          : 'Click to show ' + group.label }}" matTooltipPosition="above">
        <mat-icon class="pill-icon">{{ group.visible ? 'check_circle' : 'add_circle_outline' }}</mat-icon>
        <span class="pill-label">{{ group.label }}</span>
      </div>
    </div>
  </div>




  <!-- TABLE -->
  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table">

      <!-- ================= HEADER ================= -->
      <thead class="sticky-header">

        <!-- ROW 1 : MAIN HEADERS -->
        <tr>
          <th rowspan="2">S.No</th>
          <th rowspan="2">Ship View</th>
          <th rowspan="2">Vessel Name</th>
          <th rowspan="2">Vessel IMO</th>
          <th rowspan="2">Segment</th>
          <th rowspan="2">Capacity DWT</th>
          <th rowspan="2">Distance Travelled</th>
          <th rowspan="2">Required CII</th>
          <th rowspan="2">Attained CII</th>
          <th rowspan="2">Rating</th>

          <!-- GROUP HEADERS -->
          <ng-container *ngFor="let group of visibleGroups">
            <th class="th-text-center group-header-arrow" [attr.colspan]="getVisibleColumnsForGroup(group).length"
              (click)="toggleGroupExpand(group)"
              matTooltip="{{ group.expanded ? 'Collapse columns' : 'Expand columns' }}" matTooltipPosition="above">
              <!-- ARROW ONLY -->
              <span class="arrow-icon">
                {{ group.expanded ? '<' : '>' }} </span>

                  <!-- GROUP LABEL -->
                  <span class="group-label">
                    {{ group.label }}
                  </span>
            </th>
          </ng-container>


          <!-- <th rowspan="2">Print</th> -->
        </tr>

        <!-- ROW 2 : SUB HEADERS -->
        <tr>
          <ng-container *ngFor="let group of visibleGroups">
            <th *ngFor="let col of getVisibleColumnsForGroup(group)" class="th-sub-header">
              {{ col.label }}
            </th>
          </ng-container>
        </tr>

      </thead>

      <!-- ================= BODY ================= -->
      <tbody>
        <!-- SKELETON LOADER -->
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1,2,3,4,5]">
            <td colspan="30">
              <div class="skeleton-row animation-shimmer"></div>
            </td>
          </tr>
        </ng-container>

        <!-- ACTUAL DATA -->
        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let i = index">

            <td>{{ i + 1 }}</td>

            <td>
              <button class="gradient-btn" (click)="showDetails(element)" [ngStyle]="{
                  'background-image': 'linear-gradient(98deg,#0046de,#006063)',
                  'border-radius': '11px',
                  border: 'none'
                }">
                <mat-icon fontSet="material-icons-outlined" fontIcon="visibility" class="visiblityIcon">
                  visibility_outlined
                </mat-icon>
              </button>
            </td>

            <td>{{ element.ship_name || '-' }}</td>
            <td>{{ element.ship_imo || '-' }}</td>
            <td>{{ element.segment || '-' }}</td>
            <td>{{ +element.capacity_dwt ? (element.capacity_dwt | number:'1.0-0') : '-' }}</td>
            <td>{{ +element.distance_travelled ? (element.distance_travelled | number:'1.0-0') : '-' }}</td>
            <td>{{ +element.required_cii ? element.required_cii : '-' }}</td>
            <td>{{ +element.attained_cii ? element.attained_cii : '-' }}</td>
            <td>{{ element.rating || '-' }}</td>

            <!-- GROUP DATA -->
            <ng-container *ngFor="let group of visibleGroups">
              <td *ngFor="let col of getVisibleColumnsForGroup(group)">

                {{ formatValue(element[col.key]) }}

              </td>
            </ng-container>

            <!-- <td class="text-center">
              <mat-icon class="download-icon" matTooltip="Print Final Report" (click)="printFinalReport(element)">
                picture_as_pdf
              </mat-icon>
            </td> -->

          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>

  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" showFirstLastButtons>
  </mat-paginator>

  <!-- Old bottom floating navigator commented out:
  <div class="bottom-navigator">
    <div class="nav-arrow" matTooltip="Go Back to Dashboard" matTooltipPosition="above" (click)="goToPreviousPage()">
      ←
    </div>
  </div> -->

</div>